import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../AdminLayout';
import { getBlogsAdmin, deleteBlog, updateBlog } from '../../services/adminService';

export default function AdminBlogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = () => getBlogsAdmin().then(d => { setBlogs(d); setLoading(false); });
  useEffect(() => { load(); }, []);

  const handleDelete = async (id, title) => {
    if (!window.confirm(`Delete "${title}"?`)) return;
    await deleteBlog(id);
    setBlogs(p => p.filter(b => b.id !== id));
  };

  const togglePublish = async (b) => {
    await updateBlog(b.id, { published: !b.published });
    setBlogs(prev => prev.map(x => x.id === b.id ? { ...x, published: !x.published } : x));
  };

  const fmt = (ts) => {
    if (!ts) return '—';
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  return (
    <AdminLayout title="Blog Manager">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <button className="a-btn a-btn-primary" onClick={() => navigate('/admin/blogs/new')}>+ New Blog Post</button>
      </div>

      <div className="admin-section">
        {loading ? <div className="admin-spinner">Loading…</div> : (
          blogs.length === 0 ? (
            <div className="admin-empty" style={{ padding: 60 }}>
              <p style={{ fontSize: 16, marginBottom: 16 }}>No blog posts yet.</p>
              <button className="a-btn a-btn-accent" onClick={() => navigate('/admin/blogs/new')}>Create Your First Post</button>
            </div>
          ) : (
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr><th>Cover</th><th>Title</th><th>Category</th><th>Date</th><th>Status</th><th>Actions</th></tr>
                </thead>
                <tbody>
                  {blogs.map(b => (
                    <tr key={b.id}>
                      <td>{b.coverImage && <img src={b.coverImage} alt="" className="img-preview" />}</td>
                      <td>
                        <strong>{b.title}</strong>
                        <div style={{ fontSize: 12, color: 'var(--a-text-muted)' }}>/blog/{b.slug}</div>
                      </td>
                      <td>{b.category || '—'}</td>
                      <td style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{fmt(b.publishedAt || b.createdAt)}</td>
                      <td>
                        <span className={`badge ${b.published ? 'badge-read' : 'badge-unread'}`}>
                          {b.published ? 'Published' : 'Draft'}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button className="a-btn a-btn-sm a-btn-ghost" onClick={() => navigate(`/admin/blogs/${b.id}`)}>Edit</button>
                          <button className="a-btn a-btn-sm a-btn-ghost" onClick={() => togglePublish(b)}>
                            {b.published ? 'Unpublish' : 'Publish'}
                          </button>
                          <button className="a-btn a-btn-sm a-btn-danger" onClick={() => handleDelete(b.id, b.title)}>Delete</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        )}
      </div>
    </AdminLayout>
  );
}
